<template>
  <section class="container-fluid p-0 bodyArea">
    <div class="justify-content-start">
      <div class="pageHeader row justify-content-between">
        <div>Video Call Logs</div>

        <div v-if="$auth.isAuthenticated" class="d-flex align-items-center">
          <div class="d-flex align-items-center dropDownContainer" style="width: 320px">
            <div class="filterText">Tenant :</div>
            <model-select
              style="background: transparent; color: #fff; border: 0; height: auto"
              v-model="lastSelectedTenant"
              :options="tenants"
              name="tenantDropdown"
              id="tenantDropdownId"
              placeholder="Select Tenant"
              class="dropdownList"
              @input="queryDataBasedOnTenantSelection">
            </model-select>
          </div>

          <button id="filterSubmitBtn" class="filterWrapper submitBtn" @click="csvExport">
            Export CSV
          </button>
        </div>
      </div>

      <div class="d-flex align-items-center my-3 mr-3">
        <div v-if="$auth.isAuthenticated" class="compactFilterWrapper">
          <model-select
            style="background: transparent; color: #fff; border: 0; height: auto"
            v-model="lastSelectedLocation"
            :options="locations"
            name="locationDropdown"
            id="locationDropdownId"
            placeholder="Select Location"
            @input="queryUnits">
          </model-select>
        </div>

        <div v-if="$auth.isAuthenticated" class="compactFilterWrapper">
          <model-select
            style="background: transparent; color: #fff; border: 0; height: auto"
            v-model="lastSelectedUnit"
            :options="units"
            name="unitDropdown"
            id="unitDropdownId"
            placeholder="Select Unit"
            @input="queryAreas">
          </model-select>
        </div>

        <div v-if="$auth.isAuthenticated" class="compactFilterWrapper">
          <model-select
            style="background: transparent; color: #fff; border: 0; height: auto"
            v-model="lastSelectedArea"
            :options="areas"
            name="areaDropdown"
            id="areaDropdownId"
            placeholder="Select Area">
          </model-select>
        </div>

        <div
          v-if="$auth.isAuthenticated" class="compactFilterWrapper"
          >
          <model-select
            style="background: transparent; color: #fff; border: 0; height: auto"
            v-model="isLive"
            :options="liveOptions"
            name="liveDropdown"
            id="liveDropdownId"
            placeholder="Enable Live">
          </model-select>
        </div>

        <!--        <p style="font-size: 16px" class="ml-3 my-2">OR</p>-->
        <!--        <input-->
        <!--          type="text"-->
        <!--          v-model="searchConferenceId"-->
        <!--          class="ml-3 filterInputText"-->
        <!--          style="padding: 0 15px; line-height: 40px; width: 22%"-->
        <!--          placeholder="Conference Id"/>-->

        
      </div>

      <hr />
    </div>

    <div class="mx-3 my-3 d-flex align-items-center">
      <p class="my-2" style="font-size: 18px">Filters:</p>
      <div class="mr-3 d-flex align-items-center justify-content-start">
        <div class="d-flex align-items-center ml-3">
          <p class="m-0 ">Start Time</p>
          <div v-if="$auth.isAuthenticated" class="subFilterWrapper">
            <Datepicker class="formatDateTime mr-2" v-model="startDate" :format="format" ></Datepicker>
            <input type="time" class="formatDateTime mr-2" v-model="startTime" />
          </div>
        </div>

        <div class="d-flex align-items-center">
          <p class="m-0 ml-3">End Time</p>
          <div v-if="$auth.isAuthenticated" class="subFilterWrapper">
            <Datepicker class="formatDateTime mr-2" v-model="endDate" :format="format" ></Datepicker>
            <input type="time" class="formatDateTime mr-2" v-model="endTime" />
          </div>
        </div>
      </div>

      
        <div class="d-flex justify-content-end align-items-end">
          <button
            id="filterSubmitBtn"
            class="filterWrapper submitBtn"
            @click="fetchFilteredSessions">
            Submit
          </button>
          <button
            id="filterSubmitBtn"
            class="filterWrapper submitBtn"
            @click="resetFilters">
            Reset
          </button>
        </div>
    </div>

    <div v-if="fetchEnabled && !isDataLoading && !searchConferenceId">
      <div v-if="sessionList.length > 0">
        <div class="table-responsive tableWrapper">
          <b-table
            striped
            hover
            responsive
            id="session-table"
            :items="sessionList"
            :sort-desc="true"
            :fields="conferenceFields"
            class="table table-hover m-0 align-middle text-center">
            <template #cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <template #cell(conferenceId)="data">
              <input
                type="button"
                :value="data.value"
                :title="data.value"
                class="border-0 m-0 bg-transparent text-primary text-wrap text-truncate"
                @click="showDetailsModal(data.value)" />
            </template>
            <template #cell(location_info)="data">
              <div class="text-truncate" :title="data.value">{{ data.value }}</div>
            </template>
            <template #cell(call_duration)="data">
              {{ data.value ? parseFloat(data.value).toFixed(2) : 0 }}
            </template>
            <template #cell(callInitiatedUser)="data">
              <div class="text-truncate" :title="data.value">{{ data.value }}</div>
            </template>
            <!-- start time -->
            <template #cell(start_time)="data">
              <div>{{ data.value | dateFormat }}</div>
            </template>
            <!-- end time -->
            <template #cell(end_time)="data">
              <div>{{ data.value | dateFormat }}</div>
            </template>
          </b-table>
        </div>
        <div v-if="isSessionCallLoading">
          <div class="d-flex justify-content-center my-2">
            <div class="loader"></div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="w-100 h-100">
              <div
                class="modal-dialog-scrollable modal-dialog-centered modal-xl session mx-auto my-auto"
                role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Session Details</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true" @click="showModal = false">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div v-if="!detailsLoading && $auth.isAuthenticated">
                      <div class="table-responsive mt-4 tableWrapper shadow p-3 rounded">
                        <table>
                          <tbody>
                          <tr>
                            <th>Conference Id</th>
                            <td class="px-3">{{ conferenceData.conferenceId }}</td>
                          </tr>
                          <tr>
                            <th>Location Info</th>
                            <td class="px-3">{{ conferenceData.location_info }}</td>
                          </tr>
                          <tr>
                            <th>Start time</th>
                            <td class="px-3">{{ conferenceData.start_time | dateFormat}}</td>
                          </tr>
                          <tr>
                            <th>End time</th>
                            <td class="px-3">{{ conferenceData.end_time |dateFormat }}</td>
                          </tr>
                          <tr>
                            <th>Call Initiated User</th>
                            <td class="px-3">{{ conferenceData.callInitiatedUser }}</td>
                          </tr>
                          <tr v-if="conferenceData.call_quality_now">
                            <th>Call quality</th>
                            <td class="px-3">{{ conferenceData.call_quality_now }}</td>
                          </tr>
                          <tr>
                            <th>Intent</th>
                            <td class="px-3">{{ conferenceData.video_call_intent }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>

                      <h5 class="mx-4 my-4 fw-bold">Participants</h5>

                      <div class="overflow-auto">
                        <div class="table-responsive tableWrapper shadow p-3 rounded">
                          <b-table
                            id="details-table"
                            :items="participants"
                            :fields="sessionFields"
                            class="table table-hover m-0 align-middle text-center"
                            medium>
                            <template #cell(name)="data">
                              {{
                                data.value
                                  ? data.value.first + " " + data.value.last
                                  : data.item.display_name
                              }}
                            </template>
                            <template #cell(duration)="data">
                              {{ data.value ? parseFloat(data.value).toFixed(2) : 0 }}s
                            </template>
                          </b-table>
                        </div>
                        <br />
                        <div class="table-responsive tableWrapper shadow p-3 rounded">
                          <b-tabs content-class="mt-3">
                            <div
                              v-for="participant in conferenceData.participants"
                              :key="participant.participantUUID">
                              <b-tab :title="participant.display_name">
                                <b-table
                                  :id="participant.display_name"
                                  :items="participant.media_streams"
                                  :fields="mediaStreamFields"
                                  class="table table-hover m-0 align-middle"
                                  medium></b-table>
                              </b-tab>
                            </div>
                          </b-tabs>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="showModal = false">
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import Dropdown from "vue-simple-search-dropdown";
import { ModelSelect } from "vue-search-select";
import { keyBy } from "lodash";
import moment from 'moment';
import Datepicker from "vue2-datepicker";

Vue.use(VueToast);
Vue.filter('dateFormat', function (value, format = 'MM/DD/YYYY hh:mm:ss A') {
  // Ensure value is not null or undefined
  if (!value) return '';
  
  // Format the date using moment.js
  return moment(value).format(format);
});

export default {
  name: "VideoCalls",
  components: { Dropdown, ModelSelect,Datepicker },
  data() {
    return {
      format:"MM-DD-YYYY",
      showModal: false,
      startTime: "00:00",
      startDate: this.getStartDate(),
      endTime: "00:00",
      endDate: new Date(),
      paginationNext: "",
      tenantsList: [],
      locationsList: [],
      unitsList: [],
      areasList: [],
      sessionList: [],
      locationLookup: {},
      unitLookup: {},
      fetchEnabled: false,
      isSessionCallLoading: false,
      isDataLoading: false,
      isLive: true,
      tenants: [{ text: "", value: "" }],
      locations: [{ text: "Facility", value: "" }],
      units: [{ text: "Unit", value: "" }],
      areas: [{ text: "Areas", value: "" }],
      liveOptions: [
        { text: "Active calls", value: true },
        { text: "History", value: false }
      ],
      searchConferenceId: "",
      conferenceId: "",
      lastSelectedTenant: "",
      lastSelectedLocation: "",
      lastSelectedUnit: "",
      lastSelectedArea: "",
      conferenceData: {},
      participants: [],
      conferenceFields: [
        {
          key: "index",
          label: "Row"
        },
        {
          key: "conferenceId",
          label: "Conference Id",
          sortable: true
        },
        {
          key: "location_info",
          label: "Location",
          sortable: true,
          thStyle: { width: "10%" }
        },
        {
          key: "start_time",
          label: "Start time",
          sortable: true
        },
        {
          key: "end_time",
          label: "End time",
          sortable: true
        },
        {
          key: "call_duration",
          label: "Duration",
          sortable: true
        },
        {
          key: "callInitiatedUser",
          label: "Initiated by",
          sortable: true
        },
        {
          key: "display_name",
          label: "Participants"
        },
        {
          key: "call_quality_now",
          label: "Call Quality",
          sortable: true
        },
        {
          key: "video_call_intent",
          label: "Intent",
          sortable: true
        }
      ],
      sessionFields: [
        {
          key: "display_name",
          label: "Participant alias",
          sortable: true
        },
        {
          key: "start_time",
          label: "Start time",
          sortable: true
        },
        {
          key: "end_time",
          label: "End time",
          sortable: true
        },
        {
          key: "duration",
          label: "Duration",
          sortable: true
        },
        {
          key: "name",
          label: "Display name",
          sortable: true
        },
        {
          key: "system_location",
          label: "System location",
          sortable: true
        },
        {
          key: "protocol",
          label: "Protocol",
          sortable: true
        },
        {
          key: "role",
          label: "Role",
          sortable: true
        },

        {
          key: "call_quality_now",
          label: "Call Quality"
        },
        {
          key: "disconnect_reason",
          label: "Disconnect Reason"
        }
      ],
      mediaStreamFields: [
        {
          key: "stream_type",
          label: "Rx bitreate"
        },
        {
          key: "rx_bitrate",
          label: "Rx bitreate"
        },
        {
          key: "rx_codec",
          label: "Rx bitreate"
        },
        {
          key: "rx_fps",
          label: "Rx FPS"
        },
        {
          key: "rx_packets_lost",
          label: "Rx packets lost"
        },
        {
          key: "rx_packets_received",
          label: "Rx packets received"
        },
        {
          key: "tx_bitrate",
          label: "Tx bitrate"
        },
        {
          key: "tx_codec",
          label: "Tx codec"
        },
        {
          key: "tx_fps",
          label: "Tx FPS"
        },
        {
          key: "tx_packets_lost",
          label: "Tx packets lost"
        },
        {
          key: "tx_packets_sent",
          label: "Tx packets sent"
        },
        {
          key: "tx_resolution",
          label: "Tx resolution"
        }
      ],
      detailsLoading: true
    };
  },

  async created() {
    setTimeout(
      function() {
        this.fetchTenants();
      }.bind(this),
      1000
    );
  },


  methods: {
    getStartDate(){
      let date=new Date();
      date.setDate(date.getDate() - 3);
      return date
    },
    showDetailsModal(conferenceId) {
      this.conferenceId = conferenceId;
      this.conferenceData = {};
      this.participants = [];
      this.fetchSessionDetails();
    },
    async fetchLocationByTenant() {
      if (this.lastSelectedTenant) {
        await this.fetchLocations(this.lastSelectedTenant);
      }
    },
    async queryDataBasedOnTenantSelection() {
      await this.fetchLocationByTenant();
    },
    fetchUnitByLocation() {
      this.lastSelectedArea = "";
      if (this.lastSelectedLocation) {
        this.unitsList = [];
        const location = this.locationLookup[this.lastSelectedLocation];
        this.units = location.units;
        this.unitLookup = keyBy(this.units, "id");
        this.units = this.units.map((t) => {
          return {
            text: t.name,
            value: t.id
          };
        });
        this.units = this.units.sort((a, b) => {
          var nameA = a.text.toUpperCase(); // ignore upper and lowercase
          var nameB = b.text.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
        this.units.forEach((e) => this.unitsList.push({ id: e.value, name: e.text }));
      }
    },
    queryUnits() {
      this.lastSelectedArea = "";
      this.fetchUnitByLocation();
    },
    fetchAreasByUnit() {
      if (this.lastSelectedUnit) {
        this.areasList = [];
        const unit = this.unitLookup[this.lastSelectedUnit];
        const areas = unit.areas;
        if (areas) {
          this.areas = areas.map((t) => {
            return {
              text: t.name,
              value: t.id
            };
          });
          this.areas = this.areas.sort((a, b) => {
            var nameA = a.text.toUpperCase(); // ignore upper and lowercase
            var nameB = b.text.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
          this.areas.forEach((e) => this.areasList.push({ id: e.value, name: e.text }));
        }
      }
    },
    queryAreas() {
      this.fetchAreasByUnit();
    },
    getDropdownTenants(value) {
      return this.tenantsList.filter((e) => e.id == value || e.name == value);
    },
    getDropdownLocations(value) {
      return this.locationsList.filter((e) => e.id == value || e.name == value);
    },
    getDropdownUnits(value) {
      return this.unitsList.filter((e) => e.id == value || e.name == value);
    },
    getDropdownAreas(value) {
      return this.areasList.filter((e) => e.id == value || e.name == value);
    },
    async fetchTenants() {
      if (!this.$auth.isAuthenticated) {
        return;
      }
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var tenants_list_request = new Request(config.TENET_SERVICE + "/tenants/?list=true", {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var tenantListResponse = await fetch(tenants_list_request);
        if (tenantListResponse.status === 403) {
          Vue.$toast.open({
            message: "Uh oh... You don't have the permission required to access this resource",
            type: "error"
          });
          return;
        }
        if (tenantListResponse.status == 401) {
          Vue.$toast.open({
            message: "Your session has expired please login again to continue",
            type: "error"
          });
          return;
        }
        if (tenantListResponse.status == 503) {
          return this.fetchTenants();
        }
        if (tenantListResponse.status != 200) {
          Vue.$toast.open({
            message: "Unable to get data",
            type: "error"
          });
          return;
        } else {
          var tenantsBody = await tenantListResponse.json();
          this.tenants = tenantsBody.map((t) => {
            return {
              text: t.text || t.value,
              value: t.value
            };
          });
          this.tenants = this.tenants.sort(function(a, b) {
            var nameA = a.text.toUpperCase(); // ignore upper and lowercase
            var nameB = b.text.toUpperCase(); // ignore upper and lowercase

            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });

          this.tenants.forEach((e) =>
            this.tenantsList.push({ id: e.value, name: e.text || e.value })
          );
        }
      } catch (tex) {
        Vue.$toast.open({ message: "Failed to get tenant list due to an error.", type: "error" });
      }
    },
    async fetchLocations(tenantId) {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      this.locationsList = [];
      var locUrl = config.TENET_SERVICE + `/tenants/${tenantId}/locations?limit=500`;
      var locations_list_request = new Request(locUrl, {
        method: "GET",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var locationListResponse = await fetch(locations_list_request);
        if (locationListResponse.status === 403) {
          Vue.$toast.open({
            message: "Uh oh... You don't have the permission required to access this resource",
            type: "error"
          });
          return;
        }
        if (locationListResponse.status == 401) {
          Vue.$toast.open({
            message: "Your session has expired please login again to continue",
            type: "error"
          });
          return;
        }
        if (locationListResponse.status == 503) {
          return this.fetchLocations(tenantId);
        }
        if (locationListResponse.status != 200) {
          Vue.$toast.open({
            message: "APIs are warming up. Please refresh the page in a few seconds.",
            type: "error"
          });
        } else {
          const locationsBody = await locationListResponse.json();
          this.locations = locationsBody.locations.map((t) => {
            return {
              text: t.name,
              value: t.id
            };
          });
          this.locations = this.locations.sort((a, b) => {
            var nameA = a.text;
            var nameB = b.text;
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
          this.locations.forEach((e) => this.locationsList.push({ id: e.value, name: e.text }));
          this.locationLookup = keyBy(locationsBody.locations, "id");
        }
      } catch (tex) {
        Vue.$toast.open({
          message: "Failed to get locations list due to an error.",
          type: "error"
        });
      }
    },
    async fetchCallSessions(paginationNext) {
      if (!this.$auth.isAuthenticated) {
        return;
      }

      if (!paginationNext) {
        paginationNext = "limit=300&offset=0";
      }

      if (this.lastSelectedTenant) {
        this.fetchEnabled = true;
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var call_sessions_request = null;

        if (this.searchConferenceId) {
          this.showDetailsModal(this.searchConferenceId);
          return;
        } else {
          call_sessions_request = new Request(
            config.OPERATIONS_SERVICE + `/tenants/${this.lastSelectedTenant}/video-call-logs?${paginationNext}&isActiveCallLogs=${this.isLive}${this.lastSelectedLocation ? `&locationId=${this.lastSelectedLocation}` : ""}${this.lastSelectedUnit ? `&unitId=${this.lastSelectedUnit}` : ""}${this.lastSelectedArea ? `&areaId=${this.lastSelectedArea}` : ""}${
              this.startDate
                ? `&filterStartDateInUTC=${
                  this.startDate.format('YYYY-MM-DD') +
                  "T" +
                  this.startTime
                }`
                : ""
            }${
              this.endDate
                ? `&filterEndDateInUTC=${
                  this.endDate.format('YYYY-MM-DD') +
                  "T" +
                  this.endTime
                }`
                : ""
            }
          `,
            {
              method: "GET",
              mode: "cors",
              cache: "default",
              withCredentials: true,
              credentials: "include",
              headers: {
                Authorization: "Bearer " + id_token,
                "Content-Type": "application/json"
              }
            }
          );
        }
        try {
          this.isSessionCallLoading = true;
          var sessionResponse = await fetch(call_sessions_request);
          if (sessionResponse.status === 403) {
            Vue.$toast.open({
              message: "Uh oh... You don't have the permission required to access this resource",
              type: "error"
            });
            return;
          }
          if (sessionResponse.status == 401) {
            Vue.$toast.open({
              message: "Your session has expired please login again to continue",
              type: "error"
            });
            return;
          }

          if (sessionResponse.status == 503) {
            return this.fetchCallSessions();
          }
          if (sessionResponse.status != 200) {
            Vue.$toast.open({
              message: "Unable to get data",
              type: "error"
            });
            return;
          } else {
            var responseBody = await sessionResponse.json();

            const callLogs = responseBody["call_logs"];
            if (callLogs && callLogs.length > 0) {
              this.sessionList = [...this.sessionList, ...callLogs];
            }
            if (responseBody.next) {
              this.fetchCallSessions(responseBody.next);
            }
            this.isSessionCallLoading = false;
          }
        } catch (tex) {
          console.error("Failed to get Call Logs for error", tex);
          Vue.$toast.open({
            message: "Failed to get call logs due to an error.",
            type: "error"
          });
        }
      }
      this.isSessionCallLoading = false;
    },
    async fetchSessionDetails() {
      if (!this.$auth.isAuthenticated) {
        return;
      }

      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      this.offset = (this.currentPage - 1) * this.perPage;
      var conference_request = new Request(
        config.OPERATIONS_SERVICE +
        `/tenants/${this.tenantId}/video-call-logs/${this.conferenceId}`,
        {
          method: "GET",
          mode: "cors",
          cache: "default",
          withCredentials: true,
          credentials: "include",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json"
          }
        }
      );

      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots"
      });
      try {
        var conferenceResponse = await fetch(conference_request);
        if (conferenceResponse.status === 403) {
          Vue.$toast.open({
            message: "Uh oh... You don't have the permission required to access this resource",
            type: "error"
          });
          return;
        }
        if (conferenceResponse.status == 401) {
          Vue.$toast.open({
            message: "Your session has expired please login again to continue",
            type: "error"
          });
          return;
        }

        if (conferenceResponse.status == 503) {
          return this.fetchData();
        }
        if (conferenceResponse.status != 200) {
          Vue.$toast.open({
            message: "Unable to get data",
            type: "error"
          });
          return;
        } else {
          var responseBody = await conferenceResponse.json();
          this.conferenceData = responseBody;
          this.participants = responseBody.participants;
          this.showModal = true;
          this.detailsLoading = false;
        }
        loader.hide();
      } catch (tex) {
        loader.hide();
        Vue.$toast.open({
          message: "Failed to get conference data due to an error.",
          type: "error"
        });
      }
    },
    async fetchFilteredSessions() {
      let loader = Vue.$loading.show({
        color: "skyblue",
        opacity: 0.1,
        loader: "dots"
      });
      this.isDataLoading = true;
      this.sessionList = [];
      await this.fetchCallSessions();
      this.isDataLoading = false;
      loader.hide();
    },
    resetFilters() {
      this.lastSelectedLocation = "";
      this.lastSelectedUnit = "";
      this.lastSelectedArea = "";
      this.searchConferenceId = "";
       this.endDate = new Date();
      this.startDate = this.getStartDate();
      this.startTime = "00:00";
      this.endTime = "00:00";
      this.isLive = true;
      this.sessionList = [];
    },
    csvExport() {
      if (this.sessionList.length > 0) {
        const replacer = (_, value) => (value === null ? "" : value); // specify how you want to handle null values here
        // const header = Object.keys(this.sessionList[0]);
        // console.log('header', header);
        const header = ["conferenceId", "call_quality_now", "locationName", "unitName", "areaName", "initiated_time", "timezone", "callInitiatedUser", "start_time", "end_time", "display_name", "video_call_intent"];
        const csv = [
          header.join(","), // header row first
          ...this.sessionList.map((row) =>
            header.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(",")
          )
        ].join("\r\n");

        let csvContent = "data:text/csv;charset=utf-8,";
        csvContent += csv;
        const data = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", data);
        link.setAttribute("download", "export.csv");
        link.click();
      }
    }
  }
};
</script>
<style lang="scss">
body .dropdown .dropdown-input {
  border: none !important;
  padding: 0 15px !important;
  background: none !important;
  font-size: 16px !important;
}

body .dropdown.dropdownList .dropdown-input {
  color: #fff !important;
  border: none !important;
  padding: 0 15px !important;
  background: none !important;
  font-size: 14px !important;
}

body .dropdown .dropdown-input:focus,
body .dropdown .dropdown-input:focus-visible {
  outline: none;
}

.dropdownList input::-webkit-input-placeholder, input.filterInputText::-webkit-input-placeholder, input.search::-webkit-input-placeholder {
  color: #fff !important;
}

::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #d7d7d7 !important;
  border-radius: 10px;
}

::-webkit-scrollbar-track {
  background: #fafafa !important;
}
</style>

<style lang="scss" scoped>
@font-face {
  font-family: GTWalsheimPro-Regular;
  src: url(../assets/fonts/GTWalsheimPro-Regular.eot);
  src: url(../assets/fonts/GTWalsheimPro-Regular.eot) format('embedded-opentype'),
  url(../assets/fonts/GTWalsheimPro-Regular.ttf) format('truetype'),
  url(../assets/fonts/GTWalsheimPro-Regular.svg) format('svg');
  font-weight: normal;
  font-style: normal;
}

*,
:after,
:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

body,
html {
  font-family: GTWalsheimPro-Regular !important;
  background: #fff !important;
  font-size: 16px;
  overflow-x: hidden;
}

b,
strong {
  font-weight: 500;
}

button,
html input[type='button'],
input[type='reset'],
input[type='submit'] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
html input[disabled] {
  cursor: default;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
  outline: 0 !important;
}

a,
a img,
a:active,
a:focus,
button:focus,
a:hover {
  outline: 0 !important;
  -webkit-transition: all 0.35s;
  -moz-transition: all 0.35s;
  transition: all 0.35s;
  text-decoration: none;
  cursor: pointer;
  color: #5ed1d1;
}

a:hover {
  text-decoration: underline;
}

img {
  border: 0 !important;
}

a:focus:not(:hover),
button:focus:not(:hover) {
  outline: 0;
}

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: rgba(4, 78, 89, 1) !important;
}

::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba(4, 78, 89, 1) !important;
}

:-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(4, 78, 89, 1) !important;
}

:-moz-placeholder {
  /* Firefox 18- */
  color: rgba(4, 78, 89, 1) !important;
}

::-moz-selection {
  /* Code for Firefox */
  color: #fbeeef;
  background: #202533;
}

::selection {
  color: #fbeeef;
  background: #202533;
}

/* Scroll Bar Styling */

/* width */
::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f2fdff;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Checkbox CSS ends here */
.bodyArea {
  font-family: GTWalsheimPro-Regular;
}

.pageHeader {
  height: 56px;
  color: #fff;
  background: #484848;
  font-size: 15px;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
}

.pageHeader .filterText {
  padding-right: 0px !important;
}

.pageHeader .filterText.pad-10 {
  padding-right: 10px !important;
}

.dropDownContainer {
  background: #575757;
  display: inline-flex;
  padding: 0px 15px;
  font-size: 15px;
  border-radius: 5px;
  // margin-left: 15px;
  line-height: 36px;
  text-overflow: ellipsis;
  height:38px;
}


.subFilterWrapper {
  background: #fff;
  display: inline-flex;
  padding: 0;
  font-size: 15px;
  min-width: 250px;
  border-radius: 5px;
  margin-left: 15px;
  line-height: 34px;
  text-overflow: ellipsis;
  border: 1px solid #ebebeb;
}

.compactFilterWrapper {
  background: #fff;
    display: inline-flex;
    padding: 0px;
    font-size: 15px;
    border-radius: 5px;
    margin-left: 15px;
    line-height: 36px;
    min-width: 250px;
    text-overflow: ellipsis;
    border: 1px solid #ebebeb;
    height:38px;
}

.filterWrapper.submitBtn {
  max-width: none !important;
  min-width: 0 !important;
  border: none;
  color: #fff;
  background:#1dd8f6;
}
.pageHeader .filterWrapper.submitBtn{
  background:#575757;
}
.pageHeader .filterWrapper.submitBtn:hover{
  background:#1dd8f6;
}
.filterWrapper.submitBtn:hover{
  background:#3188D2;
}

.filterText {
  color: #fff;
  opacity: 1;
  white-space: nowrap;
}

.filterWrapper .dropdown {
  cursor: pointer;
  background: transparent !important;
  position: relative;
}

.filterWrapper .dropdown:before {
  content: '';
  border: solid #fff;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2.5px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  right: 10px;
  top: 15px;
}

.filterWrapper.exportBtn {
  max-width: none !important;
  min-width: 0 !important;
  border: none;
  color: #fff;
}

.filterWrapper select {
  width: 100%;
  text-align: left;
  border: none;
}

.filterWrapper select.active {
  color: #6a6a6a;
}

.tableWrapper {
  font-size: 14px;
  margin: auto;
  width: 97%;
  overflow: auto;
  border-radius: 10px;
  border: 1px solid lightgray;
  border-top: 0;
}

body select {
  width: 100px !important;
  overflow: hidden !important;
  white-space: nowrap;
  text-overflow: ellipsis;
}

body select option {
  width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #6a6a6a;
}

body select[data-v-33144d13] {
  width: 200px !important;
  overflow: hidden !important;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.loader {
  border: 2px solid #f3f3f3; /* Light grey */
  border-top: 2px solid #484848; /* Blue */
  border-radius: 50%;
  width: 25px;
  height: 25px;
  animation: spin 1.5s linear infinite;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.formatDateTime {
  color: #6a6a6a;
  border: 0;
  background-color: transparent;
  text-align: center;
  outline: none;
}

input[type='time']::-webkit-calendar-picker-indicator {
  // filter: invert(100%);
  cursor: pointer;
}

input[type='date']::-webkit-calendar-picker-indicator {
  // filter: invert(100%);
  cursor: pointer;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

::v-deep .ui.search.dropdown .text {
  max-width: 190px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  height: 15px;
  color: #fff;

}
.pageHeader ::v-deep .ui.search.dropdown .text{
color: #fff;
}
.compactFilterWrapper ::v-deep .ui.search.dropdown .text{
color: #6a6a6a;
}

.filterWrapper {
  line-height: 38px;
}

::v-deep .ui.dropdown .menu .item {
  max-width: 230px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

}

::v-deep .ui.selection.dropdown .menu {
  margin-top: 2px;
}

::v-deep .compactFilterWrapper .ui.dropdown .menu .item {
  max-width: 250px;
}

::v-deep .ui.active.search.dropdown input.search:focus + .text {
  color: #fff;
}

.filterInputText {
  max-width: 215px !important;
  background: #1dd8f6 !important;
  outline: none !important;
  border: 1px solid #1dd8f6 !important;
  color: #fff !important;
  padding: 4px 15px !important;
  border-radius: 5px;
  line-height: 38px !important;
}

.text-truncate {
  max-width: 85%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap !important;
}
::v-deep .table thead th{
  vertical-align: middle;
}
.modal-xl.session{
  max-width: 1367px;
}

::v-deep .ui.selection.dropdown .menu .item{
  overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    // max-width: 334px;
    margin: 0px 10px 2px;
    padding: 10px 7px !important;
    border-radius: 5px;
    border: none;
}
.pageHeader  ::v-deep .ui.default.dropdown:not(.button)>input:focus~.text, .pageHeader  ::v-deep .ui.dropdown:not(.button)>input:focus~.default.text,.pageHeader ::v-deep .ui.active.search.dropdown input.search:focus+.text{
  color:#fff !important;
}

::v-deep .ui.selection.active.dropdown .menu {
  border: 1px solid #EBEBEB;
  box-shadow: 0 2px 3px 0 rgba(34, 36, 38, .15);
  padding: 10px 0;
  margin-top: 1px;
  border-top-width: 1px !important;
}

::v-deep.b-form-btn-label-control.form-control > .btn{
  background: none !important;
}
::v-deep .ui.selection.active.dropdown:hover,::v-deep .ui.selection.active.dropdown{
  box-shadow:none;
}

::v-deep .ui.dropdown .menu>.item:hover{
  color:#1dd8f6;
  background:#EAF9FF !important;
}
::v-deep .ui.dropdown .menu>.item.selected{
  color:#1dd8f6;
  background:#fff;
}
.compactFilterWrapper .dropdown:before {
  content: "";
  border: solid #8e8e8e;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  right: 15px;
  top: 13px;
}
::v-deep .subFilterWrapper .btn{
  background: none !important;
}
::v-deep .subFilterWrapper .btn :hover{
  color: #1dd8f6 !important;

}
::v-deep .subFilterWrapper .btn :active{
  color: #1dd8f6 !important;

}
.subFilterWrapper .b-calendar .b-calendar-nav .btn :active {
  color: #1dd8f6 !important;
}
::v-deep.subFilterWrapper .btn-primary:not(:disabled):not(.disabled).active{
  color: #1dd8f6 !important;
}
</style>
